module.exports = __webpack_public_path__ + "img/s00172.48e485f9.png";